import { render } from "./DbConsole.vue?vue&type=template&id=836934e8"
import script from "./DbConsole.vue?vue&type=script&lang=js"
export * from "./DbConsole.vue?vue&type=script&lang=js"

import "./DbConsole.vue?vue&type=style&index=0&id=836934e8&lang=css"
import "./DbConsole.vue?vue&type=style&index=1&id=836934e8&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__